// Which database errors mean "this part of the database has not been set up yet" (safe to fall back)
// and which are real failures (the load must fail instead of showing cut-short numbers).

// The labor update has not been applied yet, so transactions.account_name does not exist.
// Same rule as isMissingAccountColumn in api/_costRules.js.
export function isMissingAccountColumn(error) {
  if (!error) return false;
  return /account_name/i.test(String(error.message || '')) || (error.code === '42703' && /account_name/i.test(String(error.details || '')));
}

// The table does not exist (Postgres 42P01, PostgREST PGRST205, or the matching message).
export function isMissingTable(error) {
  if (!error) return false;
  if (error.code === '42P01' || error.code === 'PGRST205') return true;
  const m = String(error.message || '');
  return /relation .* does not exist/i.test(m) || /could not find the table/i.test(m);
}

// A column the code writes does not exist yet (Postgres 42703, PostgREST PGRST204, or the matching message),
// so the database update that adds it has not been applied.
export function isMissingColumn(error) {
  if (!error) return false;
  if (error.code === '42703' || error.code === 'PGRST204') return true;
  const m = String(error.message || '');
  return /column .* does not exist/i.test(m) || /could not find the .* column/i.test(m);
}
